<mat-toolbar color="primary">
    <span>Prescription</span>
    <!-- <button mat-stroked-button class="toolbar-button" (click)="addDrug()" aria-label="Ajouter un médicament">
        <fa-icon [icon]="['fas', 'pills']" class="toolbar-fa-icon" size="2x"></fa-icon>
        &nbsp;Ajouter
    </button>
    <button mat-stroked-button class="toolbar-button" (click)="addComment()" aria-label="Ajouter un commentaire">
        <fa-icon [icon]="['fas', 'comment']" class="toolbar-fa-icon" size="2x"></fa-icon>
        &nbsp;Ajouter
    </button>
    <button mat-stroked-button class="toolbar-button" (click)="store()" aria-label="Enregistrer">
        <fa-icon [icon]="['fas', 'save']" class="toolbar-fa-icon" size="2x"></fa-icon>
    </button>
    <button mat-stroked-button class="toolbar-button" (click)="sendEHealth()" aria-label="Enregistrer">
        <fa-icon [icon]="['fas', 'paper-plane']" class="toolbar-fa-icon" size="2x"></fa-icon>
    </button>
    <span class="toolbar-spacer"></span>
    <button mat-icon-button mat-dialog-close aria-label="Fermer">
        <fa-icon [icon]="['fas', 'times']" class="toolbar-fa-icon" size="2x"></fa-icon>
    </button> -->
</mat-toolbar>
<mat-dialog-content>
    <div style="min-height:80vh;min-width:76vw;">
        <div style="width:50%;float:left;">
            <mat-tab-group>
                <mat-tab label="Médicaments">
                    <div style="">
                        <app-drug-search (selected)="selectDrugPackage($event)"></app-drug-search>
                    </div>
                </mat-tab>
                <mat-tab label="Magistrales">
                    <div style=""></div>
                </mat-tab>
                <mat-tab label="Autres">
                    <div style=""></div>
                </mat-tab>
            </mat-tab-group>
        </div>
        <div style="width:50%;float:right;">
            <app-prescription [prescription]="prescription"></app-prescription>
        </div>
    </div>
</mat-dialog-content>
<mat-dialog-actions>
    <button mat-button mat-stroked-button (click)="close()">Fermer</button>
    <button mat-button mat-stroked-button (click)="save()">Sauvegarder</button>
</mat-dialog-actions>